const SearchHistory = ({handleClick, searchItem, item_id}) => {


    return ( 
        <div className="searhhistorycontent" style={{maxWidth:"100%", width:"auto",cursor:"pointer", transition: "transform 0.3s ease-out"}} 
        onClick={()=>handleClick(searchItem)}>
            <p style={{fontWeight:"bold"}}>
                {searchItem}
            </p>
        </div>
     );
}
export default SearchHistory;